import type { Branch } from '../@types/Branch';
import type { Actions } from '../actions';
import {
  RCV_BRANCH,
  RCV_BRANCH_LIST,
  RCV_CREATE_BRANCH,
  RCV_ORGANIZATION_LIST,
  RCV_REMOVE_BRANCH,
  RCV_SEARCH_BRANCH,
  RCV_UPDATE_BRANCH,
  REQ_BRANCH,
  REQ_BRANCH_LIST,
  REQ_CLEAR_BRANCH,
  REQ_CLEAR_LIST,
  REQ_CREATE_BRANCH,
  REQ_ORGANIZATION_LIST,
  REQ_REMOVE_BRANCH,
  REQ_SEARCH_BRANCH,
  REQ_UPDATE_BRANCH,
  REQUEST_FAILED,
} from '../actions/branch';
import { RCV_CREATE_RESELLERFOR, RCV_REMOVE_RESELLERFOR } from '../actions/reseller-for';
import { requestStatus, responseStatus } from '../shared/statuses';

interface BranchesState {
  requestStatus: number;
  responseStatus: number;
  list: Branch[];
  current: Branch | null;
  organizations: Branch[];
}

const _initialState: BranchesState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  list: [],
  current: null,
  organizations: [],
};

const branchesReducer = (state: BranchesState = _initialState, action: Actions): BranchesState => {
  let list;
  let index = null;

  switch (action.type) {
    case REQ_BRANCH_LIST:
    case REQ_SEARCH_BRANCH:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH_LIST:
    case RCV_SEARCH_BRANCH:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_BRANCH:
      return {
        ...state,
        current: null,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH:
      return {
        ...state,
        current: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_BRANCH:
      return {
        ...state,
        current: null,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_BRANCH:
      list = state.list.slice();
      list.push(action.response);

      return {
        ...state,
        current: action.response,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_UPDATE_BRANCH:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPDATE_BRANCH:
    case RCV_CREATE_RESELLERFOR:
    case RCV_REMOVE_RESELLERFOR:
      list = state.list.slice();
      index = list.findIndex((b) => b.id === action.response.id);

      if (index >= 0) {
        list[index] = action.response;
      }

      return {
        ...state,
        current: action.response,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_BRANCH:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_BRANCH:
      list = state.list.slice();
      index = list.findIndex((b) => b.id === action.response.id);

      if (index >= 0) {
        list.splice(index, 1);
      }

      return {
        ...state,
        list,
        current: null,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_ORGANIZATION_LIST:
      return { ...state, organizations: [] };
    case RCV_ORGANIZATION_LIST:
      return { ...state, organizations: action.response };
    case REQ_CLEAR_BRANCH:
      return { ...state, current: null };
    case REQ_CLEAR_LIST:
      return { ...state, list: [] };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default branchesReducer;
